import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'

import { Header } from './Components'
import { ApplicationProvider, FirebaseProvider } from './Contexts'

import './App.css'
import { Footer } from './Components/Footer'

const theme = createTheme({
  typography: {
    fontFamily: "'Montserrat', sans-serif",
  },
})

function App() {
  const firebaseOptions = {
    apiKey: 'AIzaSyAfsMQEp78nb7Sj1VAMoZVmwC3x0C6YcNo',
    authDomain: 'registro-laboral-2819a.firebaseapp.com',
    projectId: 'registro-laboral-2819a',
    storageBucket: 'registro-laboral-2819a.appspot.com',
    messagingSenderId: '806089638685',
    appId: '1:806089638685:web:08a3db77725806b360d7f4',
  }

  return (
    <FirebaseProvider options={firebaseOptions}>
      <ApplicationProvider>
        <ThemeProvider theme={theme}>
          <div className="App">
            <header>
              <Header />
            </header>
            <main>
              <Outlet />
            </main>
            <footer>
              <Footer />
            </footer>
          </div>
        </ThemeProvider>
      </ApplicationProvider>
    </FirebaseProvider>
  )
}

export default App
